export default class CampaignGallery {
    previewImage;
    thumbs;

    constructor() {
        this.previewImage = document.getElementById('p2p-preview-image');
        this.thumbs = document.querySelectorAll('.p2p-product-gallery img');
        this.iframeHandler();
    }

    init() {
        if(!this.previewImage) return;
        const that = this;
        that.thumbs.forEach((thumb) => {
            thumb.addEventListener('click', (e) => {
                that.removeActiveClass();
                thumb.classList.add('p2p-product-gallery--active');
                that.previewImage.style.backgroundImage = `url('${thumb.src}')`;
            });
        });
    }

    removeActiveClass() {
        this.thumbs.forEach((thumb) => {
            thumb.classList.remove('p2p-product-gallery--active');
        });
    }

    iframeHandler() {
        window.focus();
        const p2pAboutImage = document.querySelector( '.p2p_about--image' );
        if ( ! p2pAboutImage ) return;
        window.addEventListener(
            'blur',
            () => {
                setTimeout( () => {
                    if ( document.activeElement.tagName === 'IFRAME' ) {
                        p2pAboutImage.style.display = 'none';
                        document.querySelector(
                            '.video_play_button'
                        ).style.display = 'none';
                    }
                } );
            }
        );
        const iframeMinHeight = 300;
        const iframeHeightInterval = setInterval( () => {
            if ( p2pAboutImage.querySelector( 'img.lazyloaded' ) ) {
                const imageHeight = p2pAboutImage.offsetHeight;
                document.querySelector(
                    '.p2p_video_block iframe'
                ).style.height = `${
                    imageHeight > iframeMinHeight
                        ? imageHeight
                        : iframeMinHeight
                    }px`;
                clearInterval( iframeHeightInterval );
            }
        }, 500 );
    }
}